export default __webpack_public_path__ + "static/media/RAMADA04.90d21e36.jpg";